import { render, staticRenderFns } from "./ReceiptBackup.vue?vue&type=template&id=7610e5c1&scoped=true"
import script from "./ReceiptBackup.vue?vue&type=script&lang=js"
export * from "./ReceiptBackup.vue?vue&type=script&lang=js"
import style0 from "./ReceiptBackup.vue?vue&type=style&index=0&id=7610e5c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7610e5c1",
  null
  
)

export default component.exports